import { TextInput } from "pepsico-ds";
import InputText from "../../../components/common/InputText/InputText";
import ConfigurationEditPage from "../../../components/management/PartnerGenericConfigurationPages/ConfigurationEditPage";
import useConfigurationForm from "../../../components/management/PartnerGenericConfigurationPages/hooks/useConfigurationForm";
import { genericConfigValidators } from "../../../components/management/PartnerGenericConfigurationPages/validators/genericConfigValidators";
import { paths } from "../../../routes/paths";
import "./GenericConfigurationEditPage.scss";

const GenericConfigurationEditPage = () => {
  const configKey = "generic_configuration";

  const formProps = useConfigurationForm(configKey, genericConfigValidators);
  const { formData, fieldErrors, handleInputChange } = formProps;

  const breadcrumbPath = [
    {
      href: "/",
      label: "Home",
    },
    {
      href: `../../${paths.system_setting}`,
      label: "System setting",
    },
    {
      href: `../../${paths.system_setting}/${paths.generic_configuration}/edit`,
      label: "Generic Configuration Edit",
    },
  ];

  return (
    <ConfigurationEditPage
      configKey={configKey}
      configType="generic configuration"
      headerText="Generic Configuration Edit"
      description="General configuration for the portal."
      breadcrumbPath={breadcrumbPath}
      formProps={formProps}
    >
      <InputText
        label="Administrator Destination Email"
        placeholder="Type email address"
        onChange={handleInputChange}
        className="generic-configuration-input"
        name="administrator_destination_email"
        value={formData.administrator_destination_email || ""}
        errorMessage={fieldErrors.administrator_destination_email}
        required
      />
      <TextInput
        label="Points Expiration in Days"
        placeholder="Type number of days"
        onChange={handleInputChange}
        className="generic-configuration-input"
        name="points_expiration_in_days"
        value={formData.points_expiration_in_days || ""}
        error={fieldErrors.points_expiration_in_days}
        required
        type="number"
        min={0}
      />
      <InputText
        label="WhatsApp Contact Link"
        placeholder="Type whatsApp contact link"
        onChange={handleInputChange}
        className="generic-configuration-input"
        name="whatsapp_contact_link"
        value={formData.whatsapp_contact_link || ""}
        errorMessage={fieldErrors.whatsapp_contact_link}
        required
      />
    </ConfigurationEditPage>
  );
};

export default GenericConfigurationEditPage;
